import { bool, func, string } from "prop-types"
import moment from "moment-timezone"
import { momentDateTime } from "utils/dates"

const MobileTimePicker = ({ id, name, onChange, datetime, classNames }) => {
  const handleChange = ({ target: { value: time } }) => {
    if (onChange) {
      onChange(momentDateTime(datetime, time).format())
    }
  }

  return (
    <input
      value={moment(datetime).format("HH:mm")}
      type="time"
      onChange={handleChange}
      name={name}
      className={classNames}
      id={id}
    />
  )
}

MobileTimePicker.propTypes = {
  id: string,
  name: string,
  onChange: func.isRequired,
  datetime: string.isRequired,
  twentyFourHourTime: bool.isRequired,
  classNames: string
}

export default MobileTimePicker
